export var BrandColorCategory;
(function (BrandColorCategory) {
    BrandColorCategory[BrandColorCategory["Options"] = 1] = "Options";
    BrandColorCategory[BrandColorCategory["Matrix"] = 2] = "Matrix";
    BrandColorCategory[BrandColorCategory["Ranking"] = 3] = "Ranking";
})(BrandColorCategory || (BrandColorCategory = {}));
export var ColorPaletteType;
(function (ColorPaletteType) {
    ColorPaletteType[ColorPaletteType["Preset"] = 1] = "Preset";
    ColorPaletteType[ColorPaletteType["Brand"] = 2] = "Brand";
    ColorPaletteType[ColorPaletteType["Project"] = 3] = "Project";
})(ColorPaletteType || (ColorPaletteType = {}));
export var MediaOrientation;
(function (MediaOrientation) {
    MediaOrientation[MediaOrientation["Square"] = 1] = "Square";
    MediaOrientation[MediaOrientation["Horizontal"] = 2] = "Horizontal";
})(MediaOrientation || (MediaOrientation = {}));
